// removed by extract-text-webpack-plugin
module.exports = {"Box":"jalPNYTB","GridBox":"_3lWViyU6","hoverBadge":"_1Hw10DjU","btn":"_33GTIm4s","disabled":"_1_tqCZXY","Select":"qexWopNU","sel":"_2o9sWnEC","upper":"_1ebfsEZ_","control":"_3Z_1gNBQ","slider":"_3lJK3WA4","input":"_3AJ34DPS","track":"nByF5GN4","gridBoxControls":"_2CNJpKUB"};


//////////////////
// WEBPACK FOOTER
// ./client/components/Svg.styl
// module id = 648
// module chunks = 0